<div
	class="container-fluid schedule-container schedule-desktop"
	(window:resize)="windowResized()"
	[@enterAnimation]
>
	<div class="row">
		<section id="calendar-container" class="sec-container sched col-md-9">
			<div id="calendar-content" class="row user-card shadow">
				<!-- HEADER. ============================================================== -->

				<!-- Schedule header. -->
				<div class="schedule-header">
					<!-- Search field. -->
					<div class="header-search">
						<p-autoComplete
							[(ngModel)]="mainSearch"
							[suggestions]="searchResult"
							(completeMethod)="searchFilter($event)"
							(ngModelChange)="filterSelected()"
							[size]="30"
							delay="350"
							field="formated"
							autoHighlight="false"
							forceSelection="true"
							autocomplete="none"
							emptyMessage="{{ 'GENERAL.NORESULTS' | translate }}"
							dataKey="id"
							minQueryLength="1"
							placeholder="{{ 'PLACEHOLDERS.SCHEDULESEARCH' | translate }}"
						>
							<ng-template let-item pTemplate="item">
								<span data-id="{{ item.id }}" (click)="filterSelected(item)">{{
									item.formated
								}}</span>
							</ng-template>
						</p-autoComplete>

						<fa-icon icon="search" class="fa-search"></fa-icon>
					</div>

					<!-- Info and navigation. -->
					<div class="header-nav">
						<calendar-header
							[activeDate]="activeDate"
							[mode]="selectedMode"
							(changeActiveDate)="buildActiveDate($event)"
						></calendar-header>
					</div>

					<!-- Right content. -->
					<div class="header-right">
						<freud-select-button
							[selectedOption]="selectedMode"
							(selectedOptionChange)="changeCalendarMode($event.value)"
							[options]="calendarModes"
						></freud-select-button>

						<freud-button type="button" size="sm" (click)="createNewEvent()">
							Agendar <span class="freud-icon freud-icon-plus"></span>
						</freud-button>
					</div>
				</div>
				<!-- /Schedule header. -->

				<!-- CONTENT. ============================================================= -->

				<!-- Schedule content. -->
				<div class="schedule-content">
					<!-- Loading. -->

					<!-- Calendar content. -->
					<div class="schedule-frame">
						<!-- Day calendar. -->
						<app-daycalendar
							*ngIf="selectedMode == 'Day'"
							[activeDate]="activeDate"
							[firstCall]="firstCall"
							[forceRefreshEvents]="forceRefreshEvents"
							(confirmRefreshEvents)="forceToRefreshEvents($event)"
							(showSelectedEvent)="changeActiveSidebar($event)"
							(showDayEvents)="changeActiveSidebar($event)"
							[avaibilities]="avaibilities"
						></app-daycalendar>

						<!-- Month calendar. -->
						<app-monthcalendar
							*ngIf="selectedMode == 'Month'"
							[activeDate]="activeDate"
							[firstCall]="firstCall"
							[forceRefreshEvents]="forceRefreshEvents"
							(confirmRefreshEvents)="forceToRefreshEvents($event)"
							(showDayEvents)="changeActiveSidebar($event)"
						></app-monthcalendar>

						<!-- Week calendar. -->
						<app-weekcalendar
							*ngIf="selectedMode == 'Week'"
							[activeDate]="activeDate"
							[firstCall]="firstCall"
							[forceRefreshEvents]="forceRefreshEvents"
							(showSelectedEvent)="changeActiveSidebar($event)"
							(confirmRefreshEvents)="forceToRefreshEvents($event)"
							(showDayEvents)="changeActiveSidebar($event)"
							[avaibilities]="avaibilities"
						></app-weekcalendar>
					</div>
				</div>
				<!-- /Schedule content. -->

				<!-- Schedule footer. -->
				<calendar-footer [currentTimezone]="currentTimezone"></calendar-footer>
				<!-- /Schedule footer. -->
			</div>
		</section>

		<!-- SIDEBAR ================================================================== -->
		<div class="col-md-3">
			<!--Data validation -->
			<div class="row">
				<div class="col-xs-12 sidebar-widget">
					<app-alert-info-status
						class="bank-alert-container"
					></app-alert-info-status>
				</div>
			</div>
			<!-- Profile Completion -->
			<div class="row">
				<div class="col-xs-12 sidebar-widget">
					<app-profile-completion
						[reset]="resetProfileCompletion"
						[hideDetails]="showHideDetails"
					></app-profile-completion>
				</div>
			</div>
			<!-- Chart -->
			<div class="row">
				<div class="col-xs-12 sidebar-widget">
					<app-chart-compensation></app-chart-compensation>
				</div>
			</div>
			<!-- Pendencies-->
			<promptuary-pendencies
				class="zk-mt-5 zk-block"
				[professionalId]="professionalId"
				*ngIf="professionalId"
			></promptuary-pendencies>
			<!-- Google Calendar -->
			<div class="row">
				<div class="col-xs-12 sidebar-widget">
					<google-calendar-widget></google-calendar-widget>
				</div>
			</div>
			<appointment-preview-list
				*ngIf="sidebarVisible == 'Appointments'"
				[activeSidebar]="activeSidebar"
				[selectedMode]="selectedMode"
				[forceRefreshEvents]="forceRefreshEvents"
				(changeHeight)="changeCalendarHeight($event)"
				(showTodayEvents)="changeActiveSidebar($event)"
				(showEvent)="changeActiveSidebar($event)"
			></appointment-preview-list>
		</div>

		<!-- Show details -->
		<app-details
			*ngIf="!isMobile && modalVisible === 1"
			[activeSidebar]="activeSidebar"
			(scheduleEvent)="createNewEvent($event)"
			(rescheduleEvent)="reschedule($event)"
			(showEvents)="changeActiveSidebar($event)"
			(refreshEvents)="forceToRefreshEvents($event)"
		></app-details>

		<!-- Show form. -->
	</div>
</div>

<appointment-sidebar
	(refreshEvents)="forceToRefreshEvents($event)"
></appointment-sidebar>
<appointment-details-sidebar 
	[isVisible]="modalVisible === 4"
	[activeSidebar]="activeSidebar"
	(schedulNewSessionEvent)="createNewEvent($event)"
	(rescheduleEvent)="reschedule($event)"
	(showEvents)="changeActiveSidebar($event)"
	(refreshEvents)="forceToRefreshEvents(true)"
></appointment-details-sidebar>

